const getFetchStatusStructure = (status, { api, verticalId, productId }, state, statusCode) =>
    productId
        ? {
              ...state.fetchStatuses,
              [api]: {
                  ...state.fetchStatuses[api],
                  [verticalId]: {
                      [productId]: {
                          status,
                          ...((statusCode || statusCode === 0) && { statusCode }),
                      },
                  },
              },
          }
        : {
              ...state.fetchStatuses,
              [api]: {
                  ...state.fetchStatuses[api],
                  [verticalId]: {
                      status,
                      ...((statusCode || statusCode === 0) && { statusCode }),
                  },
              },
          };

export default (status, { api, verticalId, productId }, state, statusCode, id) => ({
    lastFetched: {
        ...state.lastFetched,
        [api]: verticalId,
    },
    fetchStatuses: getFetchStatusStructure(status, { api, verticalId, productId }, state, statusCode, id),
});
